import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import ProviderManager from '../../../../provider/providerManager';
import {validateFields, validateField} from '../../../../utilities/validation/validator';
import gaParams from '../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../utilities/analytics/tracking';
import lodash from 'lodash';

export const myDeliveries = createAsyncThunk('UpdateBusinessDeliverySlotHolder/myDeliveries', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('MyDeliveries', []);
    return result;
  } catch (error) {
    return error;
  }
});

export const deliveryCallBack = createAsyncThunk('UpdateBusinessDeliverySlotHolder/dekiveryCallBack', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('doCallBack', [data.id, data.phone, data.subjects]);
    return result.Body.isSuccess;
  } catch (error) {
    return error;
  }
});

const initialState = {
  form: {
    phone: '',
    errors: {},
    rules: {},
  },
  elementIndex: '',
  myDeliveriesList: [],
  isNoDeliveries: false,
  isShowErrorPage: true,
  inError: false,
};

const UpdateBusinessDeliverySlotHolderSlice = createSlice({
  name: 'updateBusinessDeliverySlotHolder',
  initialState: initialState,

  reducers: {
    validateHandler: {
      reducer(state, action) {
        state.form = action.payload;
      },
      prepare(payload) {
        const validate = validateFields(lodash.cloneDeep(payload));
        return {payload: validate};
      },
    },

    changeHandler: {
      reducer(state, action) {
        state.form = action.payload;
      },
      prepare(payload) {
        const name = payload.target.name;
        const value = payload.target.value;
        const form = lodash.cloneDeep(payload.form);
        const validate = validateField(form, name, value);
        return {payload: validate};
      },
    },
    setIsNoDelivery: {
      reducer(state, action) {
        state.isNoDeliveries = action.payload;
      },
    },
  },

  extraReducers: {
    [myDeliveries.fulfilled]: (state, action) => {
      if (action.payload.Body != null) {
        if (action.payload.Body.items.length != 0) {
          if (action.payload.errorCode != '99' && action.payload.Header.ReturnCode == '0') {
            state.myDeliveriesList = action.payload.Body;
            gaEvent(
              gaParams.DELIVERY_SLOT_QUANTITY.category,
              gaParams.DELIVERY_SLOT_QUANTITY.eventType,
              state.myDeliveriesList.items.length
            );
          } else {
            state.isShowErrorPage = true;
          }
        } else {
          state.isNoDeliveries = true;
        }
      } else {
        state.isNoDeliveries = true;
      }
    },
  },
});

export const {setIsNoDelivery, changeHandler, validateHandler} = UpdateBusinessDeliverySlotHolderSlice.actions;

export default UpdateBusinessDeliverySlotHolderSlice.reducer;
